import React from 'react';
import PropTypes from 'prop-types';

function RelatorioReceitas({ atendimentos, agruparPor }) {
  // Agrupar atendimentos por clínica ou paciente
  const receitasAgrupadas = atendimentos.reduce((acc, atendimento) => {
    const chave =
      agruparPor === 'paciente'
        ? atendimento.nomePaciente
        : atendimento.clinica;

    if (!acc[chave]) {
      acc[chave] = { nome: chave, totalReceita: 0, totalAtendimentos: 0 };
    }

    acc[chave].totalReceita += atendimento.valor || 0;
    acc[chave].totalAtendimentos += 1;

    return acc;
  }, {});

  const receitasArray = Object.values(receitasAgrupadas);

  return (
    <div className="bg-white shadow-lg p-8 mb-8 rounded-2xl">
      <h3 className="text-2xl font-bold mb-6 text-gray-900">
        Relatório de Receitas
      </h3>

      {/* Implementação de responsividade com overflow-x-auto */}
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-200 rounded-xl shadow-md">
          <thead className="bg-blue-100">
            <tr>
              <th className="py-3 px-4 text-left text-gray-700 font-bold whitespace-nowrap">
                {agruparPor === 'paciente' ? 'Paciente' : 'Clínica'}
              </th>
              <th className="py-3 px-4 text-left text-gray-700 font-bold whitespace-nowrap">
                Total de Receitas (R$)
              </th>
              <th className="py-3 px-4 text-left text-gray-700 font-bold whitespace-nowrap">
                Total de Atendimentos
              </th>
            </tr>
          </thead>
          <tbody>
            {receitasArray.map((receita) => (
              <tr
                key={receita.nome}
                className="border-b hover:bg-blue-50 transition-colors duration-200"
              >
                <td className="py-3 px-4 text-gray-800 text-sm font-medium whitespace-nowrap">
                  {receita.nome}
                </td>
                <td className="py-3 px-4 text-gray-800 text-sm font-medium whitespace-nowrap">
                  {receita.totalReceita.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </td>
                <td className="py-3 px-4 text-gray-800 text-sm font-medium whitespace-nowrap">
                  {receita.totalAtendimentos}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

RelatorioReceitas.propTypes = {
  atendimentos: PropTypes.arrayOf(
    PropTypes.shape({
      nomePaciente: PropTypes.string,
      clinica: PropTypes.string,
      valor: PropTypes.number.isRequired, // Valor da receita gerada por atendimento
    })
  ).isRequired,
  agruparPor: PropTypes.oneOf(['paciente', 'clinica']).isRequired, // Indica se será agrupado por paciente ou clínica
};

export default RelatorioReceitas;
